import langMessages from 'common/lang'
import { LanguageValues } from 'common/types/instance'
import { ScheduleTaskStates } from 'common/types/task'

const TASK_STATUS_LABEL_IDS: Record<ScheduleTaskStates, string> = {
  [ScheduleTaskStates.PROGRESS]: 'app.pages.app.taskManager.status.progress',
  [ScheduleTaskStates.INFO]: 'app.pages.app.taskManager.status.info',
  [ScheduleTaskStates.WARNING]: 'app.pages.app.taskManager.status.warning',
  [ScheduleTaskStates.FAILURE]: 'app.pages.app.taskManager.status.failure',
  [ScheduleTaskStates.RETRY]: 'app.pages.app.taskManager.status.retry',
  [ScheduleTaskStates.SUCCESS]: 'app.pages.app.taskManager.status.success',
  [ScheduleTaskStates.REVOKED]: 'app.pages.app.taskManager.status.revoked',
  [ScheduleTaskStates.STARTED]: 'app.pages.app.taskManager.status.started',
  [ScheduleTaskStates.PENDING]: 'app.pages.app.taskManager.status.pending',
  [ScheduleTaskStates.RECEIVED]: 'app.pages.app.taskManager.status.received'
}

/** Translation key of a task state, matching the labels the status chip shows. */
export const getTaskStatusLabelId = (state: string): string =>
  TASK_STATUS_LABEL_IDS[state as ScheduleTaskStates] ?? 'app.pages.app.taskManager.status.created'

/** Reads a translation outside React, where there is no `intl` in scope.
 *  The catalogs are plain objects, so the strings stay in the same three files
 *  every component uses instead of being duplicated at the call site. Takes a
 *  locale already resolved by `resolveAppLocale`, which is the only value
 *  guaranteed to name a catalog. */
const translate = (locale: LanguageValues, id: string): string =>
  (langMessages[locale] as Record<string, string>)[id] ?? id

/** Title and body of the notification shown when a run the user launched ends. */
export const getTaskFinishedNotification = (
  locale: LanguageValues,
  taskName: string,
  state: string
): { title: string; message: string } => ({
  title: translate(locale, 'app.pages.app.taskManager.taskFinishedTitle'),
  message: translate(locale, 'app.pages.app.taskManager.taskFinishedMessage')
    .replace('{name}', taskName)
    .replace('{status}', translate(locale, getTaskStatusLabelId(state)))
})
